class ArtikelLeseprobe extends HTMLElement {
    static get observedAttributes() {
        return ['data-status'];
    }
    
    connectedCallback() {
        this.leseprobeReader = this.querySelector('.leseprobe-reader');
        this.initLeseprobe();
        document.addEventListener('leseprobe-oeffnen', () => { this.overlayStatus = 'open' });
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === "data-status") this.toggleOverlay(newValue);
    }

    toggleOverlay(value) {
        this.leseprobeOverlay = this.querySelector('.leseprobe-overlay');
        if (value === 'open') {
            if (this.istTypLeseprobe && this.leseprobeNichtGeladen) this.leseprobeLaden();
            this.leseprobeOverlay.showModal();
            if (this.istTypLeseprobe) this.leseprobeReader.focus();
            return;
        }
        this.leseprobeOverlay.close();
    }

    initLeseprobe() {
        if (this.istTypLeseprobe) {
            this.leseprobeReader.addEventListener('load', () => { 
                this.ladeindikatorStatus = 'inaktiv';
            });
        }
        this.addEventListener('submit', (event) => { 
            event.preventDefault();
            this.overlayStatus = 'open';
        });
        this.querySelector('[interaction="leseprobe-schliessen"]').addEventListener('click', () => {
            this.overlayStatus = 'close';
        });
    }

    leseprobeLaden() {
        this.leseprobeReader.src = this.leseprobeReader.dataset['src'];
        delete this.leseprobeReader.dataset['src'];
    }

    set ladeindikatorStatus(wert) {
        this.ladeIndikator = this.querySelector('.ladeindikator');
        if (this.ladeIndikator) this.ladeIndikator.setAttribute('data-status', wert);
    }

    set overlayStatus(wert) {
        this.setAttribute('data-status', wert);
    }

    get istTypLeseprobe() {
        return this.querySelector('[data-leseprobe-typ]').dataset['leseprobeTyp'] === 'reader';
    }

    get leseprobeNichtGeladen() {
        return this.leseprobeReader.hasAttribute('src') === false;
    }
}

if (!customElements.get("artikel-leseprobe")) {
    customElements.define("artikel-leseprobe", ArtikelLeseprobe);
}
